import proj4 from "proj4"
import * as turf from "@turf/turf"

// UTM zone 38N (EPSG:32638) to WGS84
const utm38n = "+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs"
const wgs84 = "WGS84"

function convertCoords(coords) {
  if (typeof coords[0] === "number") {
    const [lng, lat] = proj4(utm38n, wgs84, coords)
    return [lng, lat]
  }
  return coords.map(convertCoords)
}

function getPolygonCentroid(coords) {
  // Only works for Polygon or MultiPolygon, returns [lng, lat]
  // For MultiPolygon, use the first polygon
  let flat = coords
  if (Array.isArray(coords[0][0][0])) {
    flat = coords[0]
  }
  let x = 0,
    y = 0,
    n = 0
  flat[0].forEach(([lng, lat]) => {
    x += lng
    y += lat
    n++
  })
  return n ? [x / n, y / n] : [0, 0]
}

function convertFeature(feature, projects) {
  const out = { ...feature }
  if (out.geometry && out.geometry.coordinates) {
    out.geometry = { ...out.geometry }
    out.geometry.coordinates = convertCoords(out.geometry.coordinates)
    // Add centroid as lat/lng to properties
    if (!out.properties) out.properties = {}
    if (
      out.geometry.type === "Polygon" ||
      out.geometry.type === "MultiPolygon"
    ) {
      const centroid = getPolygonCentroid(out.geometry.coordinates)
      out.properties.lng = centroid[0]
      out.properties.lat = centroid[1]
      // Check if any project is inside this polygon
      let foundProjects = []
      if (Array.isArray(projects)) {
        try {
          const coords = out.geometry.coordinates
          if (
            out.geometry.type === "Polygon" &&
            Array.isArray(coords[0]) &&
            coords[0].length >= 4
          ) {
            for (const project of projects) {
              const distanceMeters = 1000
              const angle = Math.random() * 2 * Math.PI // random direction
              const latOffset = (distanceMeters * Math.cos(angle)) / 111320
              const lngOffset = (distanceMeters * Math.sin(angle)) / 88000
              let newLat = project.lat + latOffset
              let newLng = project.lng + lngOffset
                if(projects.length === 1) {
                    // If only one project, use its coordinates directly
                    newLat = project.lat
                    newLng = project.lng
                }

              const pt = turf.point([newLng, newLat])
              const poly = turf.polygon(coords)
              if (turf.booleanPointInPolygon(pt, poly)) {
                foundProjects.push(project)
              }
            }
          } else if (
            out.geometry.type === "MultiPolygon" &&
            Array.isArray(coords[0]) &&
            Array.isArray(coords[0][0]) &&
            coords[0][0].length >= 4
          ) {
            for (const project of projects) {
              const distanceMeters = 1000
              const angle = Math.random() * 2 * Math.PI // random direction
              const latOffset = (distanceMeters * Math.cos(angle)) / 111320
              const lngOffset = (distanceMeters * Math.sin(angle)) / 88000
              let newLat = project.lat + latOffset
              let newLng = project.lng + lngOffset

              if(projects.length === 1) {
                // If only one project, use its coordinates directly
                newLat = project.lat
                newLng = project.lng

              }

              const pt = turf.point([newLng, newLat])
              for (const polyCoords of coords) {
                const poly = turf.polygon(polyCoords)
                if (turf.booleanPointInPolygon(pt, poly)) {
                  foundProjects.push(project)
                  break
                }
              }
            }
          }
        } catch (e) {}
      }
      out.properties.projectList = foundProjects
      out.properties.blockHasProject = foundProjects.length > 0
      out.properties.color = foundProjects.length > 0 ? "blue" : "red"
    }
  }
  return out
}

export function convertGeoJsonUTMtoWGS84(geojson, projects) {
  const out = JSON.parse(JSON.stringify(geojson))
  if (out.type === "FeatureCollection") {
    out.features = out.features.map(f => convertFeature(f, projects))
  } else if (out.type === "Feature") {
    return convertFeature(out, projects)
  }
  if (out.crs) delete out.crs
  return out
}
